// @ts-nocheck
/* eslint-disable react/prop-types */
import React from 'react';
import { Box as MuiBox } from '@mui/material';

/**
 * SolyticsBox - A wrapper around MUI Box component
 *
 * A versatile container component that serves as a wrapper with access to theme
 * and allows for quick styling using the sx prop. It's the fundamental building
 * block for creating layouts.
 *
 * @component
 * @example
 * // Basic box with styling
 * <SolyticsBox sx={{ p: 2, bgcolor: 'background.paper' }}>
 *   <p>Content here</p>
 * </SolyticsBox>
 *
 * @example
 * // Box as different HTML element
 * <SolyticsBox component="section" sx={{ mb: 4 }}>
 *   <p>Section content</p>
 * </SolyticsBox>
 *
 * @example
 * // Flex container
 * <SolyticsBox sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
 *   <span>Item 1</span>
 *   <span>Item 2</span>
 * </SolyticsBox>
 *
 * @example
 * // With transitions (ref forwarding)
 * <Fade>
 *   <SolyticsBox sx={{ p: 2 }}>
 *     <p>Animated content</p>
 *   </SolyticsBox>
 * </Fade>
 */
const SolyticsBox = React.forwardRef((props, ref) => {
  return <MuiBox ref={ref} {...props} />;
});

SolyticsBox.displayName = 'SolyticsBox';

export default SolyticsBox;
